import { useSelector } from 'react-redux';
import Popup from '../../../../../../shared/components/ui/popup/Popup';
import HeaderPopup from '../../../../../../shared/components/ui/popup/headerPopup/HeaderPopup';
import cannotOpenAppletIllustration from '../../../../../../assests/classroomApplets/cannotOpenAppletIllustration.png';
import classes from './CannotOpenAppletPopup.module.css';

const CannotOpenAppletPopup = ({ onClose }) => {
    const { texts } = useSelector(state => state.translate);

    return (
        <Popup close={onClose} title={texts.cannotOpenApplet} dropClass={classes.BackdropPopupClass} dropClassBody={classes.PopupBody}>
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.cannotOpenApplet}</p>
            </HeaderPopup>
            <div className={classes.Content}>
                <div className={classes.IllustrationWrap}>
                    <img className={classes.Illustration} src={cannotOpenAppletIllustration}/>
                </div>
                <p className={classes.Message}>{texts.appletRequiresStudyGroup}</p>
            </div>
        </Popup>
    );
};

export default CannotOpenAppletPopup;